var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"route login-route",attrs:{"id":"main-content","tabindex":"-1"}},[_c('h1',{staticClass:"level-2"},[_vm._v(_vm._s(_vm.$t('loginForm.title')))]),_c('LoginForm',{on:{"success":_vm.redirectAfterLogin}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }